import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const FinanceConfigurationContainer = lazy(() =>
    import(/* webpackChunkName: "finance" */ '../ui/Configuration/FinanceConfiguration').then(m => ({
        default: m.FinanceConfiguration,
    })),
);

export const financeLocations: Location[] = [
    {
        url: '/finance/configuration',
        Component: FinanceConfigurationContainer,
    },
];
